import { render } from "./Parents.vue?vue&type=template&id=130375ca&scoped=true"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import "./Parents.vue?vue&type=style&index=0&id=130375ca&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130375ca"]])

export default __exports__